var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41342 18.5253L10.9387 12L8.45114 9.51245C6.51328 11.2944 4.29915 12.5374 2.06494 13.1954C2.29422 15.1119 3.07705 16.9748 4.41342 18.5253Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0613L5.47473 19.5866C7.02514 20.9229 8.88805 21.7058 10.8046 21.9351C11.4626 19.7009 12.7056 17.4867 14.4875 15.5489L12 13.0613Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0613 12L19.5866 5.47473C20.923 7.02515 21.7058 8.88806 21.9351 10.8046C19.7009 11.4626 17.4867 12.7056 15.5489 14.4875L13.0613 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9387L18.5253 4.41342C16.9748 3.07705 15.1119 2.29422 13.1954 2.06494C12.5374 4.29915 11.2944 6.51328 9.51245 8.45114L12 10.9387Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3559 22C14.563 21.9219 16.7492 21.1175 18.5253 19.5866L15.5499 16.6112C14.0344 18.272 12.9644 20.1349 12.3559 22Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.3559C21.9219 14.563 21.1175 16.7492 19.5866 18.5253L16.6112 15.5499C18.272 14.0344 20.1349 12.9644 22 12.3559Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.6441C3.8651 11.0356 5.72798 9.96562 7.38881 8.45013L4.41342 5.47473C2.88255 7.2508 2.07807 9.43697 2 11.6441Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6441 2C11.0356 3.8651 9.96561 5.72798 8.45012 7.38881L5.47473 4.41342C7.25079 2.88255 9.43696 2.07807 11.6441 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.77bda252596481fe207c367c3302745f.svg";
export { ForwardRef as ReactComponent };